import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AlertController } from "ionic-angular";

import { AppConfig } from "../../app/app.config";
import { Device } from "@ionic-native/device";

import { Api } from "./api";

@Injectable()
export class Api4Asp extends Api {
  constructor(
    public http: HttpClient,
    protected device: Device,
    public alertCtrl: AlertController
  ) {
    super(http, device, alertCtrl);
    this.url = AppConfig.API4ASP_URL_BASE;
  }
}



// WEBPACK FOOTER //
// ./src/providers/api/api4asp.ts